export const i18nConfig = {
    locales: ['fr', 'de', 'it'],
    defaultLocale: 'fr',
    prefixDefault: false
};